import { render } from "./TransactionList.vue?vue&type=template&id=1184da36&scoped=true&ts=true"
import script from "./TransactionList.vue?vue&type=script&lang=ts"
export * from "./TransactionList.vue?vue&type=script&lang=ts"

import "./TransactionList.vue?vue&type=style&index=0&id=1184da36&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1184da36"]])

export default __exports__